import styled from 'styled-components';
import Icon from '@klv/atoms/icon';
import Buttons from '@klv/molecules/buttons';
import Typography from '@klv/atoms/typography';
import type { ICardIcon } from '../types';

export const CardHeadline = styled(Typography)`
  margin-bottom: 1rem;
`;

export const StyledCard = styled.div<{ $variant: string; }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  ${({ theme, $variant }) => (`
    color: ${theme.card[$variant].text};
    max-width: ${theme.screenSize.s380.size}rem;
  `)}
`;

export const StyledIcon = styled(Icon)<ICardIcon>`
  margin-bottom: 1.6rem;
  ${({ $variant, theme }) => (`
    color: ${theme.card[$variant].icon};
  `)};
`;

export const StyledButtons = styled(Buttons)`
  display: inline-block;
  margin-top: 2.4rem;
  ${({ theme }) => theme.screenSize.s380.mediaQuery} {
    margin-top: 3.2rem;
  }
`;

export const StyledCopy = styled(Typography)`
  margin-bottom: 1rem;
`;
